export const API_ServerAddress: string = 'http://api.valiasrlab.com/';
